import { memo, useState } from "react";
import InvestmentIcon from "src/assets/images/investment-analysis-icon.svg";
import { WatchlistData } from "./WatchlistTable";
import DialogModal from "src/common/DialogModal";
import ListModal from "../dashboard/listModal";

interface PortfolioCardProps {
  selectedStock: WatchlistData | null;
  closeModal: () => void;
  getData: () => Promise<void>;
  openModal: boolean;
}

const PortfolioCard = (props: PortfolioCardProps) => {
  const { selectedStock, closeModal, getData, openModal } = props;
  const [notes, setNotes] = useState("");
  const [quantity, setQuantity] = useState<number>(1);
  const [buyPrice, setBuyPrice] = useState<number>(0);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm !mt-0">
      <DialogModal
        title=""
        message={
          <ListModal
            heading="Add to Portfolio"
            investmentImg={InvestmentIcon}
            StatsCard={false}
            investmentAltText={"Investment"}
            notes={notes}
            selectedStock={selectedStock}
            quantity={quantity}
            setQuantity={setQuantity}
            buyPrice={buyPrice}
            setBuyPrice={setBuyPrice}
            setNotes={setNotes}
            handleOnClick={closeModal}
            getData={getData}
            isModalOpen={openModal}
          />
        }
        isModalList={true}
        show={openModal}
        setShow={closeModal}
        handleOnClick={closeModal}
        noBackdrop={true}
      />
    </div>
  );
};

export default memo(PortfolioCard);
